import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  BedrockInvocationAudioDataLoggingEnabled,
  BedrockInvocationCloudWatchDeliveryRoleARN,
  BedrockInvocationCloudWatchLogGroup,
  BedrockInvocationEmbeddingDataLoggingEnabled,
  BedrockInvocationImageDataLoggingEnabled,
  BedrockInvocationLargeDataDeliveryS3Bucket,
  BedrockInvocationLargeDataDeliveryS3KeyPrefix,
  BedrockInvocationS3LogBucket,
  BedrockInvocationS3LogKeyPrefix,
  BedrockInvocationTextDataLoggingEnabled,
  BedrockInvocationVideoDataLoggingEnabled,
} from '../../../../Components/MetadataField/MetaGridFields';

export const AWSBedrockInvocationLoggingMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;
  const metadata = { ...resource, ...insight };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields
        state="None"
        availabilityZone="None"
        vpc="None"
        owner="None"
        createdAt="None"
      />
      {BedrockInvocationTextDataLoggingEnabled(metadata)}
      {BedrockInvocationImageDataLoggingEnabled(metadata)}
      {BedrockInvocationEmbeddingDataLoggingEnabled(metadata)}
      {BedrockInvocationVideoDataLoggingEnabled(metadata)}
      {BedrockInvocationAudioDataLoggingEnabled(metadata)}
      {BedrockInvocationS3LogBucket(metadata)}
      {BedrockInvocationS3LogKeyPrefix(metadata)}
      {BedrockInvocationCloudWatchLogGroup(metadata)}
      {BedrockInvocationCloudWatchDeliveryRoleARN(metadata)}
      {BedrockInvocationLargeDataDeliveryS3Bucket(metadata)}
      {BedrockInvocationLargeDataDeliveryS3KeyPrefix(metadata)}
    </Grid>
  );
};
